/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ContentIssueRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContentIssueTable_project$ref: FragmentReference;
export type ContentIssueTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +countTypesContentIssues: ?$ReadOnlyArray<?{|
          +type: string,
          +severity: number,
          +count: number,
        |}>,
        +contentIssues: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: ContentIssueRow_issue$ref
            |}
          |}>,
        |},
      |}
    |}>
  |},
  +$refType: ContentIssueTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContentIssueTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "typeFilters",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "lenOrder",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "url",
      "type": "TextFilters",
      "defaultValue": {
        "operator": "AND",
        "values": []
      }
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countTypesContentIssues",
                  "storageKey": null,
                  "args": [
                    v0
                  ],
                  "concreteType": "CountType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "severity",
                      "args": null,
                      "storageKey": null
                    },
                    v1
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contentIssues",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "lenOrder",
                      "variableName": "lenOrder",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "typeFilters",
                      "variableName": "typeFilters",
                      "type": "[String]"
                    },
                    v0
                  ],
                  "concreteType": "ContentIssuesConnection",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ContentIssuesEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContentIssue",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "ContentIssueRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5e91a283f686dedfe9f883a3d984a34';
module.exports = node;
